(function () {

    'use strict';

    function pxPrinterPropertiesSelectItem() {
        return {
            restrict: 'EA',
            scope: {
                items: '=',
                callback: '&'
            },
            templateUrl: 'app/components/printerPropertiesMulti/printerPropertiesSelectItem/printerPropertiesSelectItem.template.html',
            link: function (scope) {

                scope.selectItem = function (event, item) {
                    event.stopPropagation();
                    scope.callback({ item: item });
                };

                scope.closePopup = function (event) {
                    scope.callback();
                };

            }
        };
    }

    pxPrinterPropertiesSelectItem.$inject = [];

    angular
        .module('printix-admin')
        .directive('pxPrinterPropertiesSelectItem', pxPrinterPropertiesSelectItem);

})();
